/**
 * Промежуток-101%: UnvDialog/UnvDrawer → adapter поверх единого UnvUI/Drawer.
 *
 * Старый API сохранён (open / title / onClose / footer / width /
 * closeOnBackdrop / hasUnsavedChanges / onBack). Под капотом — UnvUI/Drawer.
 */
import React from 'react'
import { useTranslation } from 'react-i18next'
import UnvDrawerCore from 'components/UnvUI/Drawer'

const widthToSize = (w) => {
  if (!w) return 'md'
  const px = typeof w === 'number' ? w : parseInt(String(w), 10)
  if (!Number.isFinite(px)) return 'md'
  if (px <= 320) return 'sm'
  if (px <= 480) return 'md'
  if (px <= 640) return 'lg'
  return 'xl'
}

function UnvDrawer({
  open,
  title,
  onClose,
  children,
  footer,
  width,
  closeOnBackdrop = true,
  hasUnsavedChanges = false,
  onBack,
}) {
  const { t } = useTranslation('common')

  const safeClose = () => {
    if (hasUnsavedChanges) {
      const ok = window.confirm(
        t('common.unsaved_confirm', 'Закрыть без сохранения? Введённые данные будут потеряны.'),
      )
      if (!ok) return
    }
    if (onClose) onClose()
  }

  const titleString = typeof title === 'string' ? title : undefined
  const titleNode = title && typeof title !== 'string' ? title : null

  return (
    <UnvDrawerCore
      open={!!open}
      onClose={safeClose}
      title={titleString}
      side="right"
      size={widthToSize(width)}
      closeOnOverlay={closeOnBackdrop}
    >
      {(onBack || titleNode) && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
          {onBack ? (
            <button
              type="button"
              onClick={onBack}
              aria-label={t('common.back', 'Назад')}
              style={{
                appearance: 'none',
                border: 0,
                background: 'transparent',
                cursor: 'pointer',
                fontSize: 18,
                color: 'var(--color-text-soft)',
                padding: '4px 8px',
                borderRadius: 6,
              }}
            >
              ←
            </button>
          ) : null}
          {titleNode}
        </div>
      )}
      {children}
      {footer ? (
        <div
          style={{
            marginTop: 16,
            paddingTop: 12,
            borderTop: '1px solid var(--color-border)',
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 8,
          }}
        >
          {footer}
        </div>
      ) : null}
    </UnvDrawerCore>
  )
}

export default UnvDrawer
